import React from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import LogoEmail from "img/email-lg.svg";
import Successful from "img/check-successful.svg";

import { dayAndTime } from "components/Dates.mjs";
import { navigate } from "components/Router";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { RiMailCheckLine } from "react-icons/ri";

import { recordEvent } from "components/Analytics";
import { userAuthSetup } from "api.mjs";
import { isFollowed, updateFollowed } from "components/Profile";

import log from 'loglevel';
import { useSessionContext } from "components/Session";
import Spinner from 'react-bootstrap/Spinner';

import "sass/schedule.scss";

const ScheduleInfo = (props) => {
  const {
    isApproved,
    optOut,
    exchange,
    symbol,
    companyName,
    event: { year, quarter, conference_date },
  } = props;
  const conferenceDate = new Date(conference_date);
  const { date, day, time } = dayAndTime(conferenceDate);
  const [ email, setEmail ] = useState("");
  const [ showEmailFormModal, setShowEmailFormModal ] = useState(false);
  const [ isSubmittingEmail, setIsSubmittingEmail ] = useState(false);
  const [ showThankYouModal, setShowThankYouModal ] = useState(false);
  const [ validated, setValidated ] = useState(false);
  const { sessionContext } = useSessionContext();
  const { isLoggedIn } = sessionContext || {};

  const companyIsFollowed = isFollowed(exchange, symbol);
  log.debug("companyIsFollowed:", companyIsFollowed);
  log.debug("sessionContext:", sessionContext);

  const notifyButtonPressed = () => {
    recordEvent({ name: "NotifyMe", exchange, symbol, year, quarter });
    log.debug("ScheduleInfo::sessionContext:", sessionContext);
    if (isLoggedIn) {
      log.debug("Notify success");
      setShowThankYouModal(true);
      updateFollowed(exchange, symbol, true, sessionContext);
    } else {
      setShowEmailFormModal(true);
    }
  };
  const handleClose = () => setShowEmailFormModal(false);

  const emailChangedHandler = ({ target: { value: newEmailAddress } }) => {
    setEmail(newEmailAddress);
    // setIsEmailValid(EMAIL_ADDRESS_REGEX.test(newEmailAddress));
  };

  const submitEmail = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setIsSubmittingEmail(true);
      const data = {
        type: "send-confirmation-email",
        origin,
        email,
      };
      const notifyMe = {
        exchange,
        symbol,
        year,
        quarter,
        companyName,
        conference_date,
      };
      userAuthSetup({ data, context: { sessionContext } })
        .then((result) => {
          log.debug("userAuthSetup result", result);
          const confirmationId = result.confirmation_id;
          navigate("/mail-confirmation", { state: { email, confirmationId, notifyMe } });
        });
    }
    setValidated(true);
  };

  return (
    <>
      <div className="qno">
        <span>{ quarter.toUpperCase() }</span>
      </div>

      <p className="name">{ companyName }</p>
      <p className="info-text">
        This earning call is scheduled to happen on&nbsp;
        <span className="text-primary">{ date } at { time }</span>
      </p>
      {
        companyIsFollowed ?
        <>
          <RiMailCheckLine />{" "}
          E-Mail Alert Enabled.
          <p>
            We'll send you an email as soon as this call is ready.
          </p>
        </>
        :
        <>
          <div className="btn-container">
            <button onClick={notifyButtonPressed} type="button" className="btn btn-notify">
              <MdOutlineMarkEmailUnread />{" "}
              Notify Me
            </button>
          </div>
        </>
      }

      <Modal
        className="notify-modal"
        backdrop
        centered
        show={showEmailFormModal}
        onHide={handleClose}
      >
        <Modal.Body className="modal-body">
          <div className="img-container text-center">
            <img src={LogoEmail} alt="email" />
          </div>
          <div className="title">Enter your mail</div>
          <p className="text">
            We'll send you an email alert when { quarter.toUpperCase() } { companyName }{" "}
            is Available
          </p>
          <Form noValidate validated={validated} onSubmit={submitEmail}>
            <Form.Control type="email" placeholder="Email" value={email} onChange={emailChangedHandler} autoFocus required />
            <Form.Control.Feedback type="invalid">
              Please enter a valid email address.
            </Form.Control.Feedback>
            <div className="btn-container">
              <Button type="submit" variant="primary">
                { isSubmittingEmail ?
                  <>
                    <span className="text">
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </span>
                    {" "}
                    Sending..
                  </>
                  :
                  <>
                    Submit
                  </>
                }
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/**** Modal After Successful Submission ****/}

      <Modal className="notify-modal" centered backdrop show={showThankYouModal}>
        <Modal.Body className="modal-body">
          <div className="img-container text-center">
            <img src={Successful} alt="check" className="shadow-none" />
          </div>
          <p className="title">
            Email Alert Enabled
          </p>
          <p className="title">
            You'll be alerted for { quarter } { companyName }
          </p>
          <div className="modal-btn-container">
            <Button onClick={() => setShowThankYouModal(false)} variant="secondary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
              </svg>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ScheduleInfo;
